<script>
import validations from './helpers/validations';
import FormInput from 'v3/components/Form/Input.vue';
import { reactive } from 'vue';
import { useVuelidate } from '@vuelidate/core';

import NextButton from 'dashboard/components-next/button/Button.vue';
import wootConstants from 'dashboard/constants/globals';

export default {
  components: {
    NextButton,
    FormInput,
  },
  props: {
    onSubmit: {
      type: Function,
      default: () => {},
    },
    submitInProgress: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => {},
    },
    submitButtonText: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const formData = props.formData || {};
    const {
      description = '',
      name: title = '',
      allow_auto_assign: allowAutoAssign = true,
      conversation_list_default_filter_status: conversationListDefaultFilterStatus = '',
    } = formData;

    const normalizedFilter =
      conversationListDefaultFilterStatus &&
      conversationListDefaultFilterStatus !== wootConstants.STATUS_TYPE.OPEN
        ? conversationListDefaultFilterStatus
        : '';

    const state = reactive({
      description,
      title,
      allowAutoAssign,
      conversationListDefaultFilterStatus: normalizedFilter,
    });

    const rules = validations;
    const v$ = useVuelidate(rules, state);
    return { state, v$ };
  },
  computed: {
    conversationStatusOptions() {
      return Object.values(wootConstants.STATUS_TYPE)
        .filter(value => value !== wootConstants.STATUS_TYPE.OPEN)
        .map(value => ({
          value,
          label: this.$t(`CHAT_LIST.CHAT_STATUS_FILTER_ITEMS.${value}.TEXT`),
        }));
    },
  },
  methods: {
    handleSubmit() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }
      this.onSubmit({
        description: this.state.description,
        name: this.state.title,
        allow_auto_assign: this.state.allowAutoAssign,
        conversation_list_default_filter_status:
          this.state.conversationListDefaultFilterStatus || null,
      });
    },
  },
};
</script>

<template>
  <div class="flex-shrink-0 w-full">
    <form class="mx-0 grid gap-4" @submit.prevent="handleSubmit">
      <FormInput
        v-model="state.title"
        name="title"
        spacing="compact"
        :label="$t('TEAMS_SETTINGS.FORM.NAME.LABEL')"
        :placeholder="$t('TEAMS_SETTINGS.FORM.NAME.PLACEHOLDER')"
        :has-error="v$.title.$error"
        :error-message="v$.title.$error ? v$.title.$errors[0].$message : ''"
        @blur="v$.title.$touch"
      />
      <FormInput
        v-model="state.description"
        name="description"
        spacing="compact"
        :label="$t('TEAMS_SETTINGS.FORM.DESCRIPTION.LABEL')"
        :placeholder="$t('TEAMS_SETTINGS.FORM.DESCRIPTION.PLACEHOLDER')"
        :has-error="v$.description.$error"
        :error-message="
          v$.description.$error ? v$.description.$errors[0].$message : ''
        "
        @blur="v$.description.$touch"
      />
      <div class="w-full max-w-md">
        <label class="block mb-1 text-sm text-n-slate-11">
          {{ $t('TEAMS_SETTINGS.FORM.CONVERSATION_LIST_DEFAULT_FILTER.LABEL') }}
        </label>
        <p class="mb-2 text-xs text-n-slate-10">
          {{ $t('TEAMS_SETTINGS.FORM.CONVERSATION_LIST_DEFAULT_FILTER.HELP') }}
        </p>
        <select
          v-model="state.conversationListDefaultFilterStatus"
          class="w-full text-sm"
        >
          <option value="">
            {{
              $t(
                'TEAMS_SETTINGS.FORM.CONVERSATION_LIST_DEFAULT_FILTER.DEFAULT_OPEN'
              )
            }}
          </option>
          <option
            v-for="opt in conversationStatusOptions"
            :key="opt.value"
            :value="opt.value"
          >
            {{ opt.label }}
          </option>
        </select>
      </div>
      <div class="w-full flex items-center gap-2">
        <input v-model="state.allowAutoAssign" type="checkbox" :value="true" />
        <label for="conversation_creation">
          {{ $t('TEAMS_SETTINGS.FORM.AUTO_ASSIGN.LABEL') }}
        </label>
      </div>
      <div class="flex flex-row justify-end gap-2 py-2 px-0 w-full">
        <div class="w-full">
          <NextButton
            type="submit"
            :label="submitButtonText"
            :disabled="v$.title.$invalid || submitInProgress"
            :is-loading="submitInProgress"
          />
        </div>
      </div>
    </form>
  </div>
</template>
